<app-modal [table]="true" (modalClose)="closeModal()">
    <div class="table">
        <h4 class="table__eyebrow">Table 1</h4>
        <h2 class="table__title">Patient demographics</h2>
        <div class="table__list last-list">
            <ul class="table__column variable-column">
                <div class="table__subtitle"><p>Variable</p></div>
                <li class="table__list-item ">Age (years), median (Q1–Q3)</li>
                <li class="table__list-item highlighted">Male, n (%)</li>
                <li class="table__list-item">Race, n (%)</li>
                <li class="table__list-item indented">White</li>
                <li class="table__list-item indented">Black</li>
                <li class="table__list-item indented">Asian</li>
                <li class="table__list-item indented ">Other</li>
                <li class="table__list-item highlighted">Weight (lbs), median (Q1–Q3)</li>
                <li class="table__list-item">BMI (kg/m<sup>2</sup>), median</li>
                <li class="table__list-item indented">(Q1–Q3)</li>
                <li class="table__list-item indented ">Missing</li>
                <li class="table__list-item highlighted">Patient habits, n (%)</li>
                <li class="table__list-item highlighted indented">Smoking</li>
                <li class="table__list-item highlighted twice-indented">Current</li>
                <li class="table__list-item highlighted twice-indented">Past</li>
                <li class="table__list-item highlighted twice-indented">Never</li>
                <li class="table__list-item highlighted indented">Alcohol use</li>
                <li class="table__list-item highlighted twice-indented">Current</li>
                <li class="table__list-item highlighted twice-indented">Past</li>
                <li class="table__list-item highlighted twice-indented highlighted">Never</li>
            </ul>
            <div class="scroll">
                <ul class="table__column">
                    <div class="table__subtitle"><p>EPI (n=160)</p></div>
                    <li class="table__list-item">56 (44.5–65.0)</li>
                    <li class="table__list-item highlighted">84 (52.5)</li>
                    <li class="table__list-item blank"> </li>
                    <li class="table__list-item indented">121 (75.6)</li>
                    <li class="table__list-item indented">25 (15.6)</li>
                    <li class="table__list-item indented">2 (1.3)</li>
                    <li class="table__list-item indented">12 (7.5)</li>
                    <li class="table__list-item highlighted">156.5 (128.0–198.5)</li>
                    <li class="table__list-item blank"> </li>
                    <li class="table__list-item indented">24.0 (20.8–43.7)</li>
                    <li class="table__list-item indented">2</li>
                    <li class="table__list-item highlighted blank"> </li>
                    <li class="table__list-item highlighted indented blank blank-indent"> </li>
                    <li class="table__list-item highlighted twice-indented">69 (43.1)</li>
                    <li class="table__list-item highlighted twice-indented">44 (27.5)</li>
                    <li class="table__list-item highlighted twice-indented">47 (29.4)</li>
                    <li class="table__list-item highlighted indented blank blank-indent"> </li>
                    <li class="table__list-item highlighted twice-indented">27 (16.9)</li>
                    <li class="table__list-item highlighted twice-indented">71 (44.4)</li>
                    <li class="table__list-item highlighted twice-indented">62 (38.8)</li>
                </ul>
                <ul class="table__column">
                    <div class="table__subtitle"><p>Non-EPI (n=114)</p></div>
                    <li class="table__list-item">53.5 (42–64)</li>
                    <li class="table__list-item highlighted">51 (44.7)</li>
                    <li class="table__list-item blank"> </li>
                    <li class="table__list-item indented">79 (69.3)</li>
                    <li class="table__list-item indented">25 (21.9)</li>
                    <li class="table__list-item indented">4 (3.5)</li>
                    <li class="table__list-item indented">6 (5.3)</li>
                    <li class="table__list-item highlighted">164.0 (140.0–192.0)</li>
                    <li class="table__list-item blank"> </li>
                    <li class="table__list-item indented">25.8 (22.0–30.5)</li>
                    <li class="table__list-item indented">1</li>
                    <li class="table__list-item highlighted blank"> </li>
                    <li class="table__list-item highlighted indented blank blank-indent"> </li>
                    <li class="table__list-item highlighted twice-indented">37 (32.5)</li>
                    <li class="table__list-item highlighted twice-indented">18 (15.8)</li>
                    <li class="table__list-item highlighted twice-indented">59 (51.8)</li>
                    <li class="table__list-item highlighted indented blank blank-indent"> </li>
                    <li class="table__list-item highlighted twice-indented">31 (27.2)</li>
                    <li class="table__list-item highlighted twice-indented">23 (20.2)</li>
                    <li class="table__list-item highlighted twice-indented">60 (52.6)</li>
                </ul>
                <ul class="table__column">
                    <div class="table__subtitle"><p>Total (n=274)</p></div>
                    <li class="table__list-item">55 (44–64)</li>
                    <li class="table__list-item highlighted">135 (49.3)</li>
                    <li class="table__list-item blank"> </li>
                    <li class="table__list-item indented">200 (73.0)</li>
                    <li class="table__list-item indented">50 (18.2)</li>
                    <li class="table__list-item indented">6 (2.2)</li>
                    <li class="table__list-item indented">18 (6.6)</li>
                    <li class="table__list-item highlighted">160.5 (130.0–197.0)</li>
                    <li class="table__list-item blank"> </li>
                    <li class="table__list-item indented">25.1 (21.4–30.0)</li>
                    <li class="table__list-item indented">3</li>
                    <li class="table__list-item highlighted blank"> </li>
                    <li class="table__list-item highlighted indented blank blank-indent"> </li>
                    <li class="table__list-item highlighted twice-indented">106 (38.7)</li>
                    <li class="table__list-item highlighted twice-indented">62 (22.6)</li>
                    <li class="table__list-item highlighted twice-indented">106 (38.7)</li>
                    <li class="table__list-item highlighted indented blank blank-indent"> </li>
                    <li class="table__list-item highlighted twice-indented">58 (21.2)</li>
                    <li class="table__list-item highlighted twice-indented">94 (34.3)</li>
                    <li class="table__list-item highlighted twice-indented">122 (44.5)</li>
                </ul>
            </div>
        </div>
        <!-- Disclaimer -->
        <div class="table__disclaimer">
            <p>BMI, body mass index; EPI, exocrine pancreatic insufficiency; Q, quartile.</p>
        </div>
    </div>
</app-modal>